'use client';

import { useMobile } from '@shared/hooks';
import { TBankLoadingModalProps } from '../model/types';
import { BankLoadingDrawer } from './Drawer';
import { BankLoadingModal } from './Modal';

export const BankRedirectLoading = ({
  open,
  destination,
  onOpenChange,
  triggerElement,
}: TBankLoadingModalProps) => {
  const isMobile = useMobile();
  return isMobile ? (
    <BankLoadingDrawer
      destination={destination}
      open={open}
      onOpenChange={onOpenChange}
      triggerElement={triggerElement}
    />
  ) : (
    <BankLoadingModal
      destination={destination}
      open={open}
      onOpenChange={onOpenChange}
      triggerElement={triggerElement}
    />
  );
};
